import { useQuery } from '@tanstack/react-query';
import { awaitJSON, DagLambdaFetch, UsersLambdaFetch } from '@src/utils/fetch-utils';

export interface DagPreviousBuild {
  batch_log_url: string;
  status_batch: string;
  job_end_time?: string;
}

export interface DagBuildStatus {
  batch_job_name: string;
  batch_log_url: string;
  company: string;
  dag: string;
  status_batch: string;
  job_start_time?: string;
  job_end_time?: string;
  now: string;
  total_expected_runtime?: number;
  previous_builds?: DagPreviousBuild[];
}

const AGENCY = 'tinuiti';

export const useDagStatus = (
  enabled: boolean,
  refetchInterval: number | false
): ReturnType<typeof useQuery<DagBuildStatus[]>> =>
  useQuery({
    queryKey: ['dagStatus', AGENCY],
    enabled,
    refetchInterval,
    // Status-monitoring page: always show fresh data on revisit rather than the 5-min cache.
    refetchOnMount: 'always',
    // The page surfaces load errors itself via useSetError.
    meta: { suppressGlobalError: true },
    queryFn: async (): Promise<DagBuildStatus[]> =>
      awaitJSON<DagBuildStatus[]>(
        await UsersLambdaFetch('/dagStatus', { params: { agency: AGENCY } })
      )
  });

export interface RestartDagBuildResult {
  success: boolean;
  message?: string;
}

export const restartDagBuild = async (
  dag: string,
  batchJobName: string
): Promise<RestartDagBuildResult> =>
  awaitJSON<RestartDagBuildResult>(
    await DagLambdaFetch('/start', {
      method: 'POST',
      body: { dag, start_task_name: batchJobName, retries: 0 }
    })
  );
